import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from 'next/image';
import Breadcrumbs from "../BreadCrumb";
import { CategoryItem, ProductListResponse } from "@/lib/constants";
import axios from "axios";
import { useUserStore } from "@/stores/useUserStore";
import { useCategoriesStore } from "@/stores/useCategoriesStore";
import { MinProductItemProps } from "../Product/constants";
import MinProduct from '../Product/MinProduct';
import { useInView } from 'react-intersection-observer';


let category_slug: string[] = [];
let category_id: string[] = [];
let desktop_image_banner: string | null = null;
let mobile_image_banner: string | null = null;
let category_name: string | null = null;

const Category = () => {
  const router = useRouter();
  const { categories, getCategories } = useCategoriesStore();
  const { userInfo, getUser } = useUserStore();
  const [ productList, setProductList ] = useState<MinProductItemProps[]>([]);
  const [ query, setQuery ] = useState(true);
  const [ page, setPage ] = useState(1);
  const [ productCount, setProductCount ] = useState(-1);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ orderBy, setOrderBy ] = useState<string>('popular');
  const [userData, setUserData] = useState(getUser());
  const [categoriesData, setCategoriesData] = useState(getCategories());
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const get_category_id = async (p_category: CategoryItem[], category_id: string[]) => {
    for (let i = 0; i < p_category.length; i++) {
      if (!category_id.includes(p_category[i].id.toString())) {
        category_id.push(p_category[i].id.toString());

        if (desktop_image_banner === null && p_category[i].desktop_image_banner !== null) {
          desktop_image_banner = p_category[i].desktop_image_banner;
          category_name = p_category[i].name;
        }

        if (mobile_image_banner === null && p_category[i].mobile_image_banner !== null) {
          mobile_image_banner = p_category[i].mobile_image_banner;
          category_name = p_category[i].name;
        }
      }

      get_category_id(p_category[i].subcategory, category_id);
    }
  }

  const fetch_category_slug = async (
    path: string | string[] | undefined,
    categories: CategoryItem[] | null,
    category_id: string[],
    category_slug: string[]
  ) => {
    let category_list = categories;

    if (path !== undefined && categories !== null) {
      if (Array.isArray(path)) {
        if (path.length === 2 && path[0] === "all-category" && path[1].length > 0) {
          category_slug.push(path[1]);
        } else {
          for (let i = 0; i < path.length; i++) {
            let cc: CategoryItem[] = []

            if (category_list != null) {
              cc = category_list.filter((category) => category.slug === path[i]);
            } else {
              cc = categories.filter((category) => category.slug === path[i]);
            }

            if (cc.length > 0) {
              if (i < path.length - 1) {
                category_list = cc[0].subcategory;
              } else {
                await get_category_id(cc, category_id);
              }
            }
          }
        }
      } else if (category_list != null) {
        let cc = category_list.filter((category) => category.slug === path);

        if (cc.length > 0) {
          await get_category_id(cc, category_id);
        }
      }
    }
  }

  const handleRouteChange = () => {
    setQuery(true);
    setProductList([]);
    setPage(1);
    setOrderBy('popular');
    category_slug = [];
    category_id = [];
    mobile_image_banner = null;
    desktop_image_banner = null;
  }

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    };
  }, [router.events]);

  useEffect(() => {
    setUserData(getUser());
  }, [getUser, userInfo])

  useEffect(() => {
    setCategoriesData(getCategories());
  }, [getCategories, categories])

  if (category_slug.length === 0 && category_id.length === 0) {
    fetch_category_slug(router.query.slug, categoriesData.data, category_id, category_slug);
  }

  const fetchProductList = async () => {
    let index = [(page - 1) * 20, page * 20].toString();

    try {
      const response = await axios.get<ProductListResponse>(
        '/api/product_list',
        {
          headers: { 'Authorization': 'Bear ' + userData.token },
          params: {
            category_id: category_id.toString(),
            category_slug: category_slug.toString(),
            order_by: orderBy,
            index: index
          }
        }
      )

      setProductCount(response.data.total_count);
      setProductList(productList.concat(response.data.product_list));
      setPage(page + 1);

      if (response.data.total_count / 20 <= page) {
        setQuery(false);
      }

      setIsLoading(false);
    } catch (error) {

    }
  }

  if (query && inView && !isLoading && (category_id.length > 0 ||category_slug.length > 0)) {
    setIsLoading(true);
    fetchProductList();
  }

  return (
    <>
      <Breadcrumbs />
      {mobile_image_banner !== null && mobile_image_banner !== undefined && mobile_image_banner.length > 0 && (
        <div className="relative w-full md:hidden">
          <Image
            src={mobile_image_banner}
            alt={category_slug + " banner"}
            width={0}
            height={0}
            sizes="100vw"
            className="w-full h-auto"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30"></div>
          {category_name !== null && (
            <div className="text-white text-[32px] absolute left-0 bottom-[33px] w-full font-dmsans font-bold leading-normal">
              <div className="container">
                <p className="max-w-[200px]">{category_name}</p>
              </div>
            </div>
          )}
        </div>
      )}
      {desktop_image_banner !== null && desktop_image_banner !== undefined && desktop_image_banner.length > 0 && (
        <div className="relative hidden w-full md:block">
          <Image
            src={desktop_image_banner}
            alt={category_slug + " banner"}
            width={0}
            height={0}
            sizes="100vw"
            className="w-full h-auto"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30"></div>
          {category_name !== null && (
            <div className="text-white text-5xl absolute left-0 top-1/2 -translate-y-1/2 w-full font-dmsans font-bold -tracking-[1.44px] leading-normal">
              <div className="container">
                <p className="pl-10 max-w-[350px]">{category_name}</p>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="container mb-12 md:mb-20 mt-[49px]">
        <div className="hidden md:flex justify-between items-center h-[53px]">
          <div className="flex py-4 space-x-12">
            {/* <div className="flex items-center space-x-2">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/filter.svg"}
                alt="filter icon"
                width={16}
                height={16}
                quality={100}
              />
              <p className="text-base text-[#2C3E2F] font-dmsans -tracking-[0.32px]">Filters</p>
            </div>
            <div className="flex items-center space-x-2">
              <p className="text-base text-[#2C3E2F] font-dmsans -tracking-[0.32px]">Sort by</p>
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/arrow-down.svg"}
                alt="arrow down icon"
                width={16}
                height={16}
                quality={100}
              />
            </div> */}
          </div>
          {productCount !== -1 ? (
            <p className="text-base text-[#2C3E2F] font-dmsans -tracking-[0.32px]">{productCount + " Products"}</p>
          ) : (
            <p></p>
          )}
        </div>
        <div className="grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-4 lg:grid-cols-5">
          {productList.map((product, index) => (
            <MinProduct
              key={index}
              attribute_value_list={product.attribute_value_list}
              brand={product.brand}
              cash_back={product.cash_back}
              id={product.id}
              main_image={product.main_image}
              image={product.image}
              name={product.name}
              product_discount_percent={product.product_discount_percent}
              // product_label_bottom_left_category_page={product.product_label_bottom_left_category_page}
              // product_label_bottom_middle_category_page={product.product_label_bottom_middle_category_page}
              // product_label_bottom_right_category_page={product.product_label_bottom_right_category_page}
              // product_label_left_category_page={product.product_label_left_category_page}
              // product_label_right_category_page={product.product_label_right_category_page}
              msrp={product.msrp}
              qty={product.qty}
              sales_price={product.sales_price}
              sku={product.sku}
              slug={product.slug}
              special_price={product.special_price}
              type={product.type}
              url={product.url}
              product_variant_list={product.product_variant_list}
              attrId={null}
              customName={null}
            />
          ))}
        </div>
        <div ref={ref}></div>
      </div>
    </>
  )
}

export default Category
